angular.module("ainapp")
    .controller("WarningLetterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window", "LanguageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window, LanguageService) {

            $scope.PageName = "Warning Letters";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }




            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            }, function (err) {
                toastr.error($scope.LanguageData.NetworkError);
            })






            $scope.Init = function () {

                $scope.WarningLetter = {
                    EmployeeId: "",
                    RespondDate: "",
                    Subject: "",
                    Remarks: "",

                }

            }
            $scope.Init();





            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        MainService.WarningLettersInGrid(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error($scope.LanguageData.NetworkError);
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            "Employee.Name": {
                                type: "string",
                                editable: false,
                            },

                            RespondDate: {
                                type: "date",
                                editable: false,
                            },
                            Date: {
                                type: "date",
                                editable: false,
                            },
                            Subject: {
                                type: "string",
                                editable: false,
                            },

                            Remarks: {
                                type: "string",
                                editable: false,
                            },

                            Response: {
                                type: "string",
                                editable: false,
                            },


                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: true,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },


                columns: [
                    {
                        field: "Employee.Name",
                        title: "Employee",
                        headerTemplate: "{{LanguageData.Employee}}",
                        },
                    {
                        field: "Date",
                        title: "Date",
                        headerTemplate: "{{LanguageData.Date}}",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Subject",
                        title: "Subject",
                        headerTemplate: "{{LanguageData.Reason}}",
                        },
                    {
                        field: "Remarks",
                        title: "Remarks",
                        headerTemplate: "{{LanguageData.Remarks}}",
                        },
                    {
                        field: "RespondDate",
                        title: "RespondDate",
                        headerTemplate: "{{LanguageData.RespondDate}}",
                        template: "#= kendo.toString(kendo.parseDate(RespondDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        },
                    {
                        field: "Response",
                        title: "Response",
                        headerTemplate: "{{LanguageData.Response}}",

                        },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='Delete(dataItem)'></button>  ",
                        width: '80px'
                        },
                    ],
            };



            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {
                if (!$scope.TokenInfo.IsRemove && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToDeleteData);
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteWarningLetter($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data) {
                        $('#deleteModal').modal('hide');
                        toastr.success($scope.LanguageData.Deleted);
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }

            $scope.Edit = function (data) {
                $scope.WarningLetter = data;
            }


            $scope.SaveData = function () {

                if (!$scope.TokenInfo.IsAdd && !$scope.WarningLetter.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToAddData);
                } else if (!$scope.TokenInfo.IsEdit && $scope.WarningLetter.Id > 0 && $scope.TokenInfo.Role != 'Admin' && $scope.TokenInfo.Role != 'admin' && $scope.TokenInfo.Role != '0' && $scope.TokenInfo.Role != 'SU') {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToEditData);

                } else if ($scope.WarningLetter.EmployeeId == "") {
                    toastr.warning($scope.LanguageData.SelectEmployee);


                } else if ($scope.WarningLetter.Subject == "") {
                    toastr.warning($scope.LanguageData.EnterSubject);

                } else if ($scope.WarningLetter.Remarks == "") {
                    toastr.warning($scope.LanguageData.EnterRemarks);


                } else {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.SaveWarningLetter($scope.WarningLetter).then(function (response) {
                        if (response.data) {
                            $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.Error);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }



                }]);
